import { CLIENTS } from "../data/site";
import { Reveal } from "../components/Shared";

const TrustStrip = () => (
  <section className="border-y border-line bg-white" data-testid="trust-strip">
    <div className="mx-auto max-w-7xl px-6 py-14 lg:px-10">
      <Reveal>
        <p className="label-caps text-center" data-testid="trust-strip-label">
          Trusted by Leading Organizations
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-10 gap-y-6 sm:gap-x-14">
          {CLIENTS.map((c) => (
            <span
              key={c}
              data-testid={`trust-client-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="font-display text-sm font-bold uppercase tracking-[0.12em] text-navy/55 transition-colors duration-300 hover:text-brand sm:text-base"
            >
              {c}
            </span>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);

export default TrustStrip;
